//事件总线类，对全局事件进行管理
export default class EventBus {

    //事件容器
    static #events = {};

    constructor() {
    }
  
    // 订阅事件
    static on(type, callback) {
      if (!this.#events[type]) {
        this.#events[type] = [];
      }
      this.#events[type].push(callback);
    }
  
    // 发布事件
    static emit(type, data) {
      const callbacks = this.#events[type];
      if (callbacks) {
        callbacks.forEach((callback) => callback(data));
      }
    }
  
    // 取消订阅
    static off(type, callback) {
      const callbacks = this.#events[type];
      if (callbacks) {
        this.#events[type] = callbacks.filter((cb) => cb !== callback);
      }
    }
}
